var View = require('views/base/view');

var GroupLinkView = View.extend({
  noWrap: true,
  autoRender: true,
  initialize: function(options) {
    this.template = options.groupTemplate ? require(options.groupTemplate) : require('./templates/group-link');
    View.prototype.initialize.apply(this, arguments);
  }
});

module.exports = GroupLinkView;